import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import { FilterChipVariant } from "app/pages/sales-intelligence/common-components/filters-panel/types/commonEnums";
import type { FilterValueLifecycleStatus } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";

import type { IIndustryChipItem } from "../types";

function createIndustryChipItems(
    items: readonly string[],
    getLifecycleStatus?: (value: Partial<string>) => FilterValueLifecycleStatus,
): IIndustryChipItem[] {
    return items.map((item) => {
        const names = item.split("~");
        const text = names[1] || names[0];

        const chipProps: Partial<ChipItem> = {
            variant: FilterChipVariant.Icon,
            iconName: "group-industry",
        };

        return {
            type: "industry",
            id: item,
            text,
            chipStatus: getLifecycleStatus?.(item),
            ...chipProps,
        };
    });
}

export default createIndustryChipItems;
